function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PathContext from './pathContext';
import HistoryContext from './historyContext';

function withNavigateHOC(WrappedComponent) {
  var PathWrapper = function (_React$Component) {
    _inherits(PathWrapper, _React$Component);

    var _super = _createSuper(PathWrapper);

    function PathWrapper() {
      _classCallCheck(this, PathWrapper);

      return _super.apply(this, arguments);
    }

    _createClass(PathWrapper, [{
      key: "absolutePath",
      value: function absolutePath() {
        return absolutePathFromRelativePath(this.context.superPath, this.props.to);
      }
    }, {
      key: "navigate",
      value: function navigate() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _options$replace = options.replace,
            replace = _options$replace === void 0 ? this.props.replace : _options$replace;
        var historyContext = this.props.historyContext;

        if (!historyContext) {
          console.error("No parent Switch component with history object provided for navigation to:".concat(this.props.to));
          return;
        }

        var absolutePath = this.absolutePath();
        if (replace) historyContext.replace(absolutePath);else historyContext.push(absolutePath);
      }
    }, {
      key: "render",
      value: function render() {
        var _history$location,
            _history$location$pat,
            _this = this;

        var history = this.props.historyContext;
        var toPath = this.absolutePath();
        var isCurrent = history === null || history === void 0 ? void 0 : (_history$location = history.location) === null || _history$location === void 0 ? void 0 : (_history$location$pat = _history$location.pathname) === null || _history$location$pat === void 0 ? void 0 : _history$location$pat.startsWith(toPath);
        return React.createElement(WrappedComponent, _extends({}, this.props, {
          pathContext: this.context,
          navigate: function navigate() {
            return _this.navigate();
          },
          isCurrent: isCurrent
        }), this.props.children);
      }
    }]);

    return PathWrapper;
  }(React.Component);

  PathWrapper.contextType = PathContext;

  var historyWrapper = function (_React$Component2) {
    _inherits(historyWrapper, _React$Component2);

    var _super2 = _createSuper(historyWrapper);

    function historyWrapper() {
      _classCallCheck(this, historyWrapper);

      return _super2.apply(this, arguments);
    }

    _createClass(historyWrapper, [{
      key: "render",
      value: function render() {
        return React.createElement(PathWrapper, _extends({}, this.props, {
          historyContext: this.context
        }), this.props.children);
      }
    }]);

    return historyWrapper;
  }(React.Component);

  historyWrapper.contextType = HistoryContext;
  return historyWrapper;
}

export default withNavigateHOC;

function absolutePathFromRelativePath(superPath, toPath) {
  if (toPath.startsWith('/')) return toPath;
  var fullPathSegments = superPath.split('/').filter(function (s) {
    return s != '';
  });
  var toPathSegments = toPath.split('/');

  while (toPathSegments[0] === '..') {
    fullPathSegments.pop();
    toPathSegments.shift();
  }

  var absolutePath = "/".concat(fullPathSegments.concat(toPathSegments.filter(function (s) {
    return s != '';
  })).join('/'));
  return absolutePath;
}